export class RoutineTabContentTrigger extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.addEventListener('click', this.onTriggerClick.bind(this))
  }

  onTriggerClick (event) {
    const clickedTrigger = event.target
    // Find the closest parent 'tab-content' element
    const tabContentBlock = clickedTrigger.closest('tab-content')
    const matchingValue = clickedTrigger.getAttribute('data-tab-content-trigger')

    if (!tabContentBlock) return
    tabContentBlock.scrollIntoView({ behavior: 'smooth', block: 'start' })

    // Activate the trigger and the parent 'tab-content' if the values match
    this.activateTriggerAndContent(clickedTrigger, matchingValue)
  }

  activateTriggerAndContent (clickedTrigger, matchingValue) {
    // Find the nearest section or container that holds all 'tab-content' elements
    const tabContentSection = clickedTrigger.closest('.sec-TabContent')

    if (!tabContentSection) return

    const allTabContents = tabContentSection.querySelectorAll('tab-content')

    allTabContents.forEach(tabContent => {
      // Get the value of 'data-tab-content-block' attribute of each 'tab-content'
      const contentValue = tabContent.getAttribute('data-tab-content-block')

      if (matchingValue === contentValue) {
        // If the values match, activate this 'tab-content' and its trigger
        tabContent.classList.add('is-active')
        clickedTrigger.classList.add('is-active')
      } else {
        // Deactivate all other 'tab-content' elements and their triggers
        tabContent.classList.remove('is-active')
        const triggers = tabContent.querySelectorAll('routine-tab-content-trigger')
        triggers.forEach(trigger => trigger.classList.remove('is-active'))
      }
    })
  }
}

if (!customElements.get('routine-tab-content-trigger')) {
  customElements.define('routine-tab-content-trigger', RoutineTabContentTrigger)
}
